// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { ValuedMessage, ValuedMessageT, verifyValuedMessage } from "../ln2/valued-message";
import { MethodCall, MethodCallT, verifyMethodCall } from "./method-call";

/**
 * Outbound mapping: an LN2 command -> call an OPC UA method.
 */
export class MessageToMethodEntry implements flatbuffers.IUnpackableObject<MessageToMethodEntryT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): MessageToMethodEntry {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsMessageToMethodEntry(
    bb: flatbuffers.ByteBuffer,
    obj?: MessageToMethodEntry,
  ): MessageToMethodEntry {
    return (obj || new MessageToMethodEntry()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsMessageToMethodEntry(
    bb: flatbuffers.ByteBuffer,
    obj?: MessageToMethodEntry,
  ): MessageToMethodEntry {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new MessageToMethodEntry()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  key(obj?: ValuedMessage): ValuedMessage | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new ValuedMessage()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  value(obj?: MethodCall): MethodCall | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new MethodCall()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  static startMessageToMethodEntry(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addKey(builder: flatbuffers.Builder, keyOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, keyOffset, 0);
  }

  static addValue(builder: flatbuffers.Builder, valueOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, valueOffset, 0);
  }

  static endMessageToMethodEntry(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // key
    builder.requiredField(offset, 6); // value
    return offset;
  }

  unpack(): MessageToMethodEntryT {
    return new MessageToMethodEntryT(
      this.key() !== null ? this.key()!.unpack() : null,
      this.value() !== null ? this.value()!.unpack() : null,
    );
  }

  unpackTo(_o: MessageToMethodEntryT): void {
    _o.key = this.key() !== null ? this.key()!.unpack() : null;
    _o.value = this.value() !== null ? this.value()!.unpack() : null;
  }

  unpackFields(...fields: string[]): MessageToMethodEntryT {
    const t = new MessageToMethodEntryT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("key")) {
      t.key = this.key() !== null ? this.key()!.unpack() : null;
    }
    if (fieldSet.has("value")) {
      t.value = this.value() !== null ? this.value()!.unpack() : null;
    }
    return t;
  }
}

export class MessageToMethodEntryT implements flatbuffers.IGeneratedObject {
  constructor(
    public key: ValuedMessageT | null = null,
    public value: MethodCallT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.key === null || this.key === undefined) {
      throw new Error('Required field "key" is not set');
    }
    if (this.value === null || this.value === undefined) {
      throw new Error('Required field "value" is not set');
    }
    const key = this.key !== null ? this.key!.pack(builder) : 0;
    const value = this.value !== null ? this.value!.pack(builder) : 0;

    MessageToMethodEntry.startMessageToMethodEntry(builder);
    MessageToMethodEntry.addKey(builder, key);
    MessageToMethodEntry.addValue(builder, value);

    return MessageToMethodEntry.endMessageToMethodEntry(builder);
  }

  clone(): MessageToMethodEntryT {
    const obj = new MessageToMethodEntryT();
    obj.key = this.key !== null ? this.key!.clone() : null;
    obj.value = this.value !== null ? this.value!.clone() : null;
    return obj;
  }

  equals(other: MessageToMethodEntryT): boolean {
    if (this.key !== null && other.key !== null) {
      if (!this.key!.equals(other.key!)) return false;
    } else if (this.key !== other.key) return false;
    if (this.value !== null && other.value !== null) {
      if (!this.value!.equals(other.value!)) return false;
    } else if (this.value !== other.value) return false;
    return true;
  }
}

export function verifyMessageToMethodEntry(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyValuedMessage(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "key");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyMethodCall(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "value");
  } finally {
    verifier.popDepth();
  }
}
